<template>
  <div>
    <base-header v-once pageName="일정상세" :bfClose="true" :popup="true" v-on:beforeClose="checkNreload"></base-header>

    <template v-if="isDeledted">
      <section id="wrap">
        <div class="schedule-view">
          해당 EP가 삭제한 일정입니다.
        </div>
      </section>
      <div class="btnWrap">
          <button @click="reqReloadParent" type="button" class="red">확인</button>
      </div>
    </template>
    <template v-if="!isDeledted">
      <section id="wrap">
        <div class="schedule-view">
          <h6>{{mySchedule.sttDt}} ({{mySchedule.dow}}) <em v-if="mySchedule.allYn !='Y'">{{getScheduleHr()}}</em></h6>
          <div v-if="['SSD03', 'SSD07'].includes(mySchedule.scdlDivCd)" class="info">
            <strong>{{mySchedule.etcCntn}}</strong>
          </div>
          <div v-else class="info">
            <em>{{ mySchedule.custDivDetailNm }}</em>
            <strong>{{mySchedule.custNm}} <span>고객님</span></strong>
            <i>{{mySchedule.scdlDivNm}}</i>
            <p v-if="mySchedule.scdlDivCd =='SSD06'"><b>{{mySchedule.username2}}</b> <span>{{mySchedule.orgnzPstnNm2}}</span></p>
          </div>

          <div class="meetPlace">
            <p>
              <strong>{{mySchedule.addrNm}}</strong>
            </p>
            <p>
              <strong>{{mySchedule.addr}}</strong>
            </p>
            <p>
              <strong>{{mySchedule.addrDtpt}}</strong>
            </p>
          </div>
          <dl v-if="mySchedule.memo">
            <dt>메모</dt>
            <dd>
              {{mySchedule.memo}}
            </dd>
          </dl>
        </div>
      </section>
      <div class="btnWrap">
          <button @click="delMyschedule" type="button" class="black">삭제</button>
          <button @click="goToModi" type="button" class="red">수정</button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "MySchedule",
  data() {
    return {          
      prevRoute: null,
      params: {
          sqno: -1,
      },
      isDeledted: false,
      mySchedule: {
        sqno: 0,
        acmpScdlSqno: 0,
        userid: '',
        username2: '',
        orgnzPstnNm2: '',
        custDivCd: '',
        custNm: '',
        scdlDivCd: '',
        scdlDivNm: '',
        etcCntn: '',
        allYn: '',
        sttDt: '',
        dow:'',
        sttHr: '',
        endDt: '',
        endHr: '',
        addrNm: '',
        addr: '',
        addrDtpt: '',
        memo: '',
        cmplYn: '',
        dltnYn: ''      
      }      
    };
  },
  beforeRouteEnter(to, from, next) { 
    // 이 컴포넌트를 렌더링하는 라우트 앞에 호출됩니다.
    // 이 가드가 호출 될 때 아직 생성되지 않았기 때문에
    // this 컴포넌트 인스턴스에 접근 할 수 없습니다
    next(vm=> {
      vm.prevRoute= from  // 이 페이지에 오기전 페이지 설정.
    })
  },
  methods: {
    delMyschedule(){ // 스케줄 삭제
      var that = this;
      if(!confirm("입력한 일정을 삭제하시겠습니까?")){
        return;
      }
      
      var params = {cudType:"D",sqno:this.mySchedule.sqno};      
      console.log("MyScheduleView.vue delMyschedule params", params);

      this.$api.myschedule.saveMyschedule(params)
        .then(function() {
          that.reqReloadParent();
        })
        .catch(function(error) {
          alert(error.rtMsg); 
        });
    },
    checkNreload(){ // 닫기 버튼 클릭시 이전페이지에 따른 처리 후 닫기.
      var link = this.prevRoute.path;
      console.log("checkNreload", link);

      if(link && link.indexOf("/myScheduleReg") > -1){ // 수정화면을 갔다왔으면 부모창 리로드
        this.reqReloadParent();
      }
    },
    reqReloadParent(){ // 부모창 리로드호출
        var child = {
          name: "reload-myschedule"
        };
        this.$utils.nativeIf.outbound.sendChildData(child);
    },
    goToModi(){ // 수정화면으로 보내기
        //console.log("MyScheduleView.vue goToModi this.params.sqno:"+this.params.sqno);
        this.$router.push('/mySchedule/myScheduleReg/' + this.params.sqno).then((() =>window.scrollTo(0,0) )); // 이동후 맨 위로 이동.
      // var child = {
      //   name: "go-to-modi",
      //   data: {}
      // };
      // this.$utils.nativeIf.outbound.sendChildData(child);
    },
    close(){ // 닫기 버튼 클릭시 내일정목록화면으로 보내기
      //this.$router.push({ path: '/mySchedule/myScheduleList' });
      this.$utils.nativeIf.outbound.close();
    },
    getScheduleHr(){ // 같은날 시작시각 종료시각이 같을 때는 시작시각만 보여준다.
      if(this.mySchedule.sttDt == this.mySchedule.endDt && this.mySchedule.sttHr == this.mySchedule.endHr){
        return this.mySchedule.sttHr;
      }
      else{
        return this.mySchedule.sttHr + ' ~ ' + this.mySchedule.endHr;
      }
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    //console.log("MyScheduleView.vue mounted this.$route.params.sqno:"+this.$route.params.sqno);
    
    var that = this;
    that.params.sqno = this.$route.params.sqno;
    console.log("MyScheduleView.vue mounted that.params.sqno", that.params.sqno);
    
    this.$api.myschedule.getMyschedule(that.params)
      .then(function(res) {
        console.log("MyScheduleView.vue mounted <api.myschedule.getMyschedule.response>", res.mySchedule);
        if(!res.mySchedule || res.mySchedule.dltnYn == 'Y'){
          that.isDeledted = true;
        }else{
          that.mySchedule = res.mySchedule;
        }
      })
      .catch(function(error) {
        alert(error.rtMsg); 
      });
  },
  beforeUpdate: function() {}
};
</script>